import { motion } from "framer-motion";
import styles from './SolutionSection.module.css';
import { container, item } from "../../../utils/animations";
import { useTranslation } from "react-i18next";
import { SolutionCard } from "./SolutionCard";
import { useWindowsDimension } from "../../../../hooks/useWindowsDimension";

export const SolutionSection = () => {
    const { isMobile } = useWindowsDimension();
    const {t} = useTranslation();
    
    return (
        <motion.div
            className={styles.wrapper}
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{
                once: true,
                amount: 0.2,
            }}
        >
            <div className={styles.container}>
                <div className={styles.leftWrapper}>
                    <motion.h1
                        className={styles.title}
                        variants={item}
                    >
                        {t('home.solutionSection.title')}
                    </motion.h1>

                    <div className={styles.cardList}>
                        <SolutionCard 
                            title={t('home.solutionSection.cards.title.one')} 
                            description={t('home.solutionSection.cards.description.one')} 
                            color={'#F6F8EF'} 
                        />
                        <SolutionCard 
                            title={t('home.solutionSection.cards.title.two')} 
                            description={t('home.solutionSection.cards.description.two')} 
                            color={'#E2A9F1'} 
                        />
                        <SolutionCard 
                            title={t('home.solutionSection.cards.title.three')} 
                            description={t('home.solutionSection.cards.description.three')} 
                            color={'#F6F8EF'} 
                        />
                    </div>
                </div>
                { !isMobile &&
                    <motion.div className={styles.rightWrapper} variants={item}>
                        <img
                            src={require("../../../../assets/images/mobile_home.png")}
                            alt="Gluten Freends App"
                            className={styles.phoneImage}
                            
                        />
                        <img
                            src={require("../../../../assets/images/pink_shadow.png")}
                            alt=""
                            className={styles.shadowImage}
                        />
                    </motion.div>
                }
            </div>
        </motion.div>
    )
}